module.exports = __webpack_public_path__ + "static/waka-waka-logo--47423e7903ca81060f7f5fe25d3c4225.png";